<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Tasks"
};
</script>

<style></style>
